import { render, staticRenderFns } from "./SSearchRequirement.vue?vue&type=template&id=2422193e"
import script from "./SSearchRequirement.vue?vue&type=script&lang=js"
export * from "./SSearchRequirement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports